import {
  FETCH_TRIGGER_FILTERS_START,
  FETCH_TRIGGER_FILTERS_SUCCESS,
  UPDATE_TRIGGER_FILTER_SUCCESS,
  FETCH_TRIGGER_FILTER_STEP_SUCCESS,
  LOAD_MORE_TRIGGER_FILTERS_START,
  LOAD_MORE_TRIGGER_FILTERS_SUCCESS,
  SET_TRIGGER_FILTER_AVAILABLE_OUTPUTS,
} from 'actions/triggerFilters';
import pick from 'lodash/pick';

const initialState = {
  triggerFilters: [],
  sortBy: 'TRIGGER_NAME',
  sortOrder: 'DESCENDING',
  loading: false,
  total: 0,
  links: {},
  success: false,
};

export default function triggerFilters(state = initialState, action) {
  switch (action.type) {
    case LOAD_MORE_TRIGGER_FILTERS_START:
    case FETCH_TRIGGER_FILTERS_START:
      return {
        ...state,
        loading: true,
        ...pick(action, ['sortBy', 'sortOrder']),
      };
    case FETCH_TRIGGER_FILTERS_SUCCESS:
      return {
        ...state,
        triggerFilters: action.payload.data,
        total: action.payload.total,
        loading: false,
        links: action.payload.links ?? {},
        success: true,
      };
    case UPDATE_TRIGGER_FILTER_SUCCESS:
      return {
        ...state,
        triggerFilters: state.triggerFilters.map(t =>
          t.id === action.payload.id ? { ...t, ...action.payload } : t,
        ),
      };
    case FETCH_TRIGGER_FILTER_STEP_SUCCESS:
      return {
        ...state,
        triggerFilters: state.triggerFilters.map(t =>
          t.id === action.triggerId
            ? {
                ...t,
                availableOutputs: action.payload.outputs.data.map(o => o.name),
              }
            : t,
        ),
      };
    case LOAD_MORE_TRIGGER_FILTERS_SUCCESS:
      return {
        ...state,
        triggerFilters: state.triggerFilters.concat(action.payload.data),
        loading: false,
        links: action.payload.links ?? {},
      };
    case SET_TRIGGER_FILTER_AVAILABLE_OUTPUTS:
      return {
        ...state,
        triggerFilters: state.triggerFilters.map(t =>
          t.id === action.triggerFilterId
            ? { ...t, availableOutputs: action.outputs }
            : t,
        ),
      };
    default:
      return state;
  }
}
